var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry-chip",style:({ backgroundColor: _vm.getIndustryColor })},[_vm._v("\n  "+_vm._s(_vm.industry.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }